import React from 'react';
import PropTypes from 'prop-types';
import {useDispatch, useSelector} from 'react-redux';
import {FmlxMenu, FmlxIcon} from 'fmlx-common-ui';
import {getCopiedPipettingParameter} from 'stores/selectors/protocolEditorSelectors';
import withIntl from 'lib/withIntl';
import {copyPipettingParameterTask, pastePipettingParameterTask} from 'stores/business/protocolEditorBusiness';
import {CardType} from 'constants/dataEnum';
import {showApplyPipettingConfirmationModal} from 'stores/business/pipettingParameterBusiness';
import {CopyPipettingValueMode} from 'constants/cardStateEnum';

function TaskContextMenu({intl, hideContextMenu, task, isDisableContexMenu, contextMenuTask}) {
  const dispatch = useDispatch();
  const copiedPipettingParameter = useSelector(getCopiedPipettingParameter);

  const handleCopyPipettingParameter = async () => {
    if (task?.taskList) {
      await dispatch(copyPipettingParameterTask(task.taskList[0]));
    }
    hideContextMenu();
  };

  const handlePastePipettingParameter = async () => {
    hideContextMenu();

    if (task?.taskList || task.length !== 0) {
      const callback = () => dispatch(pastePipettingParameterTask(task));

      dispatch(showApplyPipettingConfirmationModal(CopyPipettingValueMode.TO_SINGLE_TASK, callback));
    }
  };

  const isPastePipettingParameterTaskDisabled = (type = null) => {
    const selectedTask = task?.taskList;
    if (!selectedTask || (selectedTask?.length === 0 && !copiedPipettingParameter?.type)) {
      return true;
    }

    let taskType = type;
    if (!taskType) {
      taskType = selectedTask[0]?.type;
    }

    if (copiedPipettingParameter?.type) {
      if (taskType !== copiedPipettingParameter.type || copiedPipettingParameter.type === CardType.SIMPLE_TRANSFER) {
        return true;
      }
    } else {
      return true;
    }

    return false;
  };

  function renderSubContextMenu() {
    const contextMenuItem = [];
    const isDisablePasteMenu = isPastePipettingParameterTaskDisabled();

    contextMenuItem.push({
      label: intl.formatMessage({id: 'protocolEditor.taskList.menuContext.copy'}),
      icon: <FmlxIcon name="ContentCopy" size="xs" />,
      onClick: handleCopyPipettingParameter,
    });

    if (!isDisablePasteMenu) {
      contextMenuItem.push({
        label: intl.formatMessage({id: 'protocolEditor.taskList.menuContext.paste'}),
        icon: <FmlxIcon name="FilePaste" size="xs" />,
        onClick: handlePastePipettingParameter,
      });
    }
    return contextMenuItem;
  }

  return (
    <FmlxMenu
      open={contextMenuTask.contextMenu !== null}
      onClose={hideContextMenu}
      isDisable={isDisableContexMenu}
      anchorPosition={
        contextMenuTask.contextMenu !== null
          ? {top: contextMenuTask.contextMenu.mouseY, left: contextMenuTask.contextMenu.mouseX}
          : undefined
      }
      anchorReference="anchorPosition"
      listItem={renderSubContextMenu()}
      anchorEl={contextMenuTask.anchorEl}
    />
  );
}

TaskContextMenu.propTypes = {
  intl: PropTypes.any.isRequired,
  hideContextMenu: PropTypes.func,
  task: PropTypes.object,
  isDisableContexMenu: PropTypes.bool.isRequired,
  contextMenuTask: PropTypes.object.isRequired,
};

TaskContextMenu.defaultProps = {
  hideContextMenu: () => {},
  task: {},
};

export default withIntl(TaskContextMenu);
